module.exports = __webpack_public_path__ + "static/img/shendusikaoIcon.dfd41c69.svg";